import React from 'react';
import ProgressBarWithInlineMarkers from 'components/pure/utils/ProgressBarWithInlineMarkers';
import ExpandShrinkButton from 'components/pure/utils/CardExpandShrinkButton';
import generateProgressMarkers from './generateProgressMarkers';
import formatSeconds from 'utils/formatSeconds';
import DifferenceIndicator from './DifferenceIndicator';
import HelpHover from 'components/pure/utils/HelpHover';
import HelpText from '$pages/$rep-profile/tooltips/HelpText';
import './RepProfileCallDaySummary.styl';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const disclaimer = `Note that this includes only calls longer than the minimum duration configured for the rep's department; i.e. calls under this duration are not included in the total.`;

export default class RepProfileCallDaySummary extends React.PureComponent {
  render() {
    const {callDurationSecondsMean, dayBucket, maxCallDurationSeconds, maxCallsPlaced} = this.props;
    const {callDurationSeconds, callsPlaced, date, teamCallDurationSeconds, teamCallsPlaced} =
      dayBucket;
    const callsPlacedPercent = (callsPlaced / maxCallsPlaced) * 100;
    const teamCallsPlacedPercent =
      teamCallsPlaced > 0 ? (teamCallsPlaced / maxCallsPlaced) * 100 : 0;
    const callDurationPercent = (callDurationSeconds / maxCallDurationSeconds) * 100;
    const teamCallDurationPercent =
      teamCallDurationSeconds > 0 ? (teamCallDurationSeconds / maxCallDurationSeconds) * 100 : 0;
    const callDurationDifference =
      ((callDurationSeconds - callDurationSecondsMean) / callDurationSecondsMean) * 100;
    return (
      <div
        className="day-summary"
        onClick={() => this.props.openCallDetails(this.props.rep.id, date)}>
        <div className="date day-summary-item">{date.format('dddd MM/DD/YYYY')}</div>
        <div className="progress-with-title day-summary-item">
          <HelpHover
            text={() => (
              <HelpText
                text={`The number of calls received or placed by the rep during this day.`}
                disclaimer={disclaimer}
              />
            )}
            className="title">
            {callsPlaced} Calls
          </HelpHover>
          <div className="content">
            <ProgressBarWithInlineMarkers
              percentage={callsPlacedPercent}
              color={getMuiV4Theme().palette.primary.main}
              markers={generateProgressMarkers({
                percentage: teamCallsPlacedPercent,
                formattedValue: teamCallsPlaced,
              })}
            />
          </div>
        </div>
        <div className="progress-with-title day-summary-item">
          <HelpHover
            text={() => (
              <HelpText
                text={`The total duration of calls received or placed by the rep during this day.`}
                disclaimer={disclaimer}
              />
            )}
            className="title">
            {formatSeconds(callDurationSeconds)}
          </HelpHover>
          <div className="content">
            <ProgressBarWithInlineMarkers
              percentage={callDurationPercent}
              color={getMuiV4Theme().palette.primary.dark}
              markers={generateProgressMarkers({
                percentage: teamCallDurationPercent,
                formattedValue: formatSeconds(teamCallDurationSeconds),
              })}
            />

            <HelpHover
              className="difference-container"
              text={() => (
                <HelpText
                  text="This is the difference between the average number of calls
                    made/received by the rep today and their average from the
                    selected duration."
                  disclaimer={disclaimer}
                />
              )}>
              <DifferenceIndicator measure={callDurationDifference} />
            </HelpHover>
          </div>
        </div>
        <ExpandShrinkButton expanded={this.props.expanded} className="day-summary-item" />
      </div>
    );
  }
}
